module.exports = __webpack_public_path__ + "static/img/care-2.5b4b0b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/describe/care-2.png
// module id = S+52
// module chunks = 1